<app-user-select
  [onlyActive]="false"
  (select)="onSelect($event)"
  [hideLabel]="true"
  [parentFormGroup]="form"
  [roleType]="roleType"
  class="kendo-select-filter"
  [isInModal]="false"
>
</app-user-select>
